import {
    REQUEST_MLD_TWEET_SENTIMENT,
    RESPONSE_MLD_TWEET_SENTIMENT,
    FAILURE_MLD_TWEET_SENTIMENT
  } from "../../actions/types";
  
  const initialState = {
    error: false,
    isLoading: false,
    isInitialScreen: true,
    total: 0,
    results: [],
    filters: {
      keywords: [],
      confs: [],
      year: [],
      country: []
    },
    keyword: "",
    size: 20,
    from: 0,
    activePage: 1
  };
  
  const setFetching = (state, action) => {
    let filters = action.payload.filters;
    let keyword = action.payload.keyword;
    let isLoading = action.payload.isLoading;
  
    if (isLoading === false) {
      return {
        ...state,
        isLoading: isLoading,
        error: false,
        filters,
        keyword,
        results: [],
        total: 0,
      };
    }
    return {
      ...state,
      isLoading: isLoading,
      error: false,
      filters,
      keyword,
      isInitialScreen: false
    };
  };
  
  const setFailure = (state, action) => {
    return {
      ...state,
      isLoading: false,
      error: true,
      results: []
    };
  };
  
  const setResults = (state, action) => {
    let results = action.payload.results || [];
    let total = action.payload.total || 0;
    return {
      ...state,
      isLoading: false,
      error: false,
      results,
      total
    };
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_MLD_TWEET_SENTIMENT:
        return setFetching(state, action);
        break;
  
      case RESPONSE_MLD_TWEET_SENTIMENT:
        return setResults(state, action);
  
      case FAILURE_MLD_TWEET_SENTIMENT:
        return setFailure(state, action);
  
      default:
        return state;
        break;
    }
  };
  